import script from "./koparkaWynikTable.vue?vue&type=script&async=true&setup=true&lang=ts"
export * from "./koparkaWynikTable.vue?vue&type=script&async=true&setup=true&lang=ts"

import "./koparkaWynikTable.vue?vue&type=style&index=0&id=299e4693&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299e4693"]])

export default __exports__